import React from 'react';
const testimonials = [{
  initials: 'MG',
  name: 'Mariela G.',
  location: 'Córdoba',
  level: 'Primaria',
  quote: 'Compré el PROFEPACK un domingo. El lunes tenía todo el año organizado. El solucionario es un lujo — corrijo en minutos.'
}, {
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  level: 'Primaria y Secundaria',
  quote: 'Empecé con Primaria y a los 3 días compré el Pack Completo. Cada tomo tiene solucionario integrado. Ya no pierdo tiempo corrigiendo.'
}, {
  initials: 'FL',
  name: 'Fernando L.',
  location: 'Tucumán',
  level: 'Primaria',
  quote: 'Está organizado POR GRADO y alineado al currículo argentino. Es como tener un colega experto que ya hizo todo el trabajo por mí.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  level: 'Secundaria',
  quote: 'Mis alumnos de 3° y 4° por fin enganchan con la clase. El contenido los conecta con temas reales. Ya no peleo con el celular.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-12 sm:py-16 px-4" data-id="element-191">
      <div className="max-w-4xl mx-auto" data-id="element-192">
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-2" data-id="element-193">
          +3.000 docentes <span className="text-[#FF6B00]" data-id="element-194">ya lo usan</span>
        </h2>
        <p className="text-gray-400 text-center text-sm sm:text-base mb-8" data-id="element-195">
          Esto dicen sobre PROFEPACK:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-196">
          {testimonials.map(t => <div key={t.initials} className="bg-black border border-[#FF6B00]/30 rounded-xl p-4 sm:p-5 flex flex-col gap-3" data-id="element-197">
              <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-198">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-2.5" data-id="element-199">
                <div className="w-9 h-9 rounded-full bg-[#FF6B00]/20 border border-[#FF6B00]/40 flex items-center justify-center text-[#FF6B00] font-black text-xs flex-shrink-0" data-id="element-200">
                  {t.initials}
                </div>
                <div data-id="element-201">
                  <div className="text-white font-bold text-sm leading-tight" data-id="element-202">
                    {t.name}{' '}
                    <span className="text-gray-500 font-normal" data-id="element-203">
                      · {t.location}
                    </span>
                  </div>
                  <div className="text-[#FF6B00] text-xs" data-id="element-204">
                    ⭐⭐⭐⭐⭐ · {t.level}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}